import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ConfirmationContent } from "../components/Modal/ConfirmationContent";
import VaulDrawer from "../components/Modal/vaulModal";
;
const AsyncModal = ({ onConfirm, onDismiss, children, submitText, dismissText, ...props }) => {
    return (_jsx(VaulDrawer, { onClose: onDismiss, ...props, children: _jsx(VaulDrawer.Snap, { id: "item-1", children: _jsx(ConfirmationContent, { submitText: submitText, dismissText: dismissText, onConfirm: onConfirm, onDismiss: onDismiss, children: children }) }) }));
};
const AsyncModalContext = React.createContext(null);
const AsyncModalProvider = ({ children }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogConfig, setDialogConfig] = React.useState(undefined);
    const openDialog = ({ content, actionCallback, submitText, dismissText }) => {
        setDialogOpen(true);
        setDialogConfig({ content, actionCallback, submitText, dismissText });
    };
    const resetDialog = () => {
        setDialogOpen(false);
    };
    const onConfirm = () => {
        resetDialog();
        dialogConfig?.actionCallback(true);
    };
    const onDismiss = () => {
        resetDialog();
        dialogConfig?.actionCallback(false);
    };
    return (_jsxs(AsyncModalContext.Provider, { value: { openDialog }, children: [_jsx(AsyncModal, { show: dialogOpen, setShow: setDialogOpen, onConfirm: onConfirm, onDismiss: onDismiss, onAnimationEnd: (v) => !v && setDialogConfig(undefined), submitText: dialogConfig?.submitText, dismissText: dialogConfig?.dismissText, modalId: "asyncModal", children: dialogConfig?.content }), children] }));
};
const useAsyncModal = () => {
    const context = React.useContext(AsyncModalContext);
    if (context === undefined) {
        throw new Error('useAsyncModal must be used within a AsyncModalProvider');
    }
    const getConfirmation = ({ content, dismissText, submitText }) => new Promise((res) => {
        context.openDialog({ content, actionCallback: res, submitText, dismissText });
    });
    return { getConfirmation };
};
export { AsyncModalProvider, useAsyncModal };
